const getCustomColumns = (payloadCustomColumns, customColumns, contactCustomColumns) => {
	return customColumns.map(({id, name, options}) => {
		const customColumn = {id, name, options};
		const query = ({id}) => id === customColumn.id;
		if (payloadCustomColumns.some(query)) {
			return {
				...customColumn,
				options: customColumn.options
					.filter((opt) => opt.id === payloadCustomColumns.find(query).optionId)
					.map(({id, option}) => ({id, option}))
			};
		}
		if (contactCustomColumns.some(query)) {
			return {
				...customColumn,
				options: customColumn.options
					.filter((opt) => opt.id === contactCustomColumns?.find(query)?.options[0]?.id)
					.map(({id, option}) => ({id, option}))
			};
		}

		return {
			...customColumn,
			options: []
		};
	});
};

export default (entities, payload, customColumns) => {
	return entities.map((entity) => {
		if (entity.contacts.some(({userId}) => payload.contactIds.includes(userId))) {
			return {
				...entity,
				contacts: entity.contacts.map((contact) => {
					if (payload.contactIds.includes(contact.userId)) {
						let newCustomColumns = getCustomColumns(
							payload?.customColumns,
							customColumns,
							contact.customColumns
						)?.filter((cc) => cc?.options.length > 0);

						return {...contact, customColumns: newCustomColumns};
					}
					return {...contact};
				})
			};
		}
		return {...entity};
	});
};
